import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


export default function CardHeaderActions({ className, children, ...props }) {
  return (
    <div {...props} className={classNames(className, 'card-header-actions')}>
      {children}
    </div>
  );
}

CardHeaderActions.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
